import { c as _c } from "react/compiler-runtime";
import { HighlightedText, type TextSegment } from "@/components/HighlightedText";
import { ProfileImage } from "@/components/ProfileImage";
const aboutSectionContent = {
  title: "Hi, I'm Dimitar",
  paragraphs: [[{
    text: "I'm a "
  }, {
    text: "Front End Developer",
    highlight: true
  }, {
    text: " focused on building clean, web interfaces. I enjoy working with modern technologies and creating "
  }, {
    text: "smooth",
    highlight: true
  }, {
    text: ", reliable web experiences."
  }], [{
    text: "I like turning ideas into well-structured, "
  }, {
    text: "responsive",
    highlight: true
  }, {
    text: " interfaces and paying attention to the small details that make products feel polished."
  }]] as TextSegment[][]
};
export const AboutSection = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <figure aria-label="Profile picture of Dimitar Daskalov" className="flex-1 flex justify-center items-center min-w-[16rem]"><ProfileImage size="md" priority={true} /></figure>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <section aria-labelledby="about-heading" className="w-full flex flex-col lg:flex-row justify-evenly items-stretch gap-4">{t0}<article aria-labelledby="about-heading" className="flex flex-col flex-1 min-w-0 h-64 md:h-80"><h1 id="about-heading" className="heading-1 mb-6 text-glow">{aboutSectionContent.title}</h1>{aboutSectionContent.paragraphs.map(_temp)}</article></section>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
function _temp(segments, idx) {
  return <p key={idx} className="body-large"><HighlightedText segments={segments} /></p>;
}